import React from "react";

import CreateCircularForm from "../components/CreateCircularForm";

//  Circular Components
const Circular = () => {
  return (
    <>
      <section className="body-font relative text-gray-600">
        <div className="container mx-auto flex px-5 py-4">
          <div className="flex w-full flex-col items-end rounded-lg bg-white p-8">
            <h2 className="title-font  text-lg font-medium text-gray-900 mb-4">إرسال تعميم</h2>
            <CreateCircularForm />
          </div>
        </div>
      </section>
    </>
  );
};

export default Circular;
